"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveConfig = void 0;
var resolve_config_1 = require("./resolve-config");
Object.defineProperty(exports, "resolveConfig", { enumerable: true, get: function () { return resolve_config_1.resolveConfig; } });
//# sourceMappingURL=index.js.map